import styles from './LinkButton.module.css'

import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react'

interface LinkButtonProps
  extends Omit<
    DetailedHTMLProps<
      ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    >,
    'style'
  > {}

export function LinkButton({ className, ...other }: LinkButtonProps) {
  return <button className={className + ' ' + styles['btn-link']} {...other} />
}
